export const cellWidth = 150;
export const firstCellWidth = 80;
export const rowHeight = 32;
